import {Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {RecordData, RecordDataValue, RecordTableColumnParams} from "../../../../../types/records-table.types";
import {RecordsTableService} from "../../../../../services/records-table.service";
import {
  RecordsTableAddRecordFormService
} from "../../../services/records-table-add-record-form.service";
import {TableContextService} from "../../../../../services/table-services/table-context.service";

@Component({
  selector: 'app-table-new-row',
  standalone: false,
  templateUrl: './table-new-row.component.html',
  styleUrls: [
    '../../../records-table-view.component.scss',
    '../table-body/table-body.component.scss',
    './table-new-row.component.scss'
  ]
})
export class TableNewRowComponent implements OnInit {
  @Input({ required: true }) tableColumnsParams: Array<RecordTableColumnParams> = [];
  @Input({ required: true }) resourceParamsKey: string = '';
  @Input() isAnyTableActionAvailable: boolean = true;
  @Output() newRecordDataChanged: EventEmitter<Partial<RecordData>> = new EventEmitter<Partial<RecordData>>();

  private recordsTableService: RecordsTableService = inject(RecordsTableService);
  private recordsTableAddRecordFormService: RecordsTableAddRecordFormService = inject(RecordsTableAddRecordFormService);
  private tableContextService: TableContextService = inject(TableContextService);

  public newRecordData!: Partial<RecordData>;

  public ngOnInit(): void {
    this.newRecordData = this.recordsTableAddRecordFormService.createEmptyRecordData(this.tableColumnsParams);
  }

  public updateRecordDataForCreation(recordDataKey: string, value: RecordDataValue): void {
    this.newRecordData[recordDataKey] = this.hasIdProperty(value) ? value.id : value;
    this.newRecordDataChanged.emit(this.newRecordData);
  }

  public getWidth(columnParam: RecordTableColumnParams): number {
    return this.recordsTableService.getColumnWidth(columnParam, this.tableContextService.getTableId());
  }

  protected isColumnDisplayed(columnParams: RecordTableColumnParams): boolean {
    return this.recordsTableService.isColumnDisplayed(columnParams);
  }

  private hasIdProperty(value: RecordDataValue): value is { id: string | number } {
    return value !== null &&
      typeof value === 'object' &&
      'id' in value;
  }
}
